import { useSearchDateShortcut } from '@/hooks/useSearch'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { StatisticalContinueRecord } from './statistical-continue.service'

interface StatisticalContinueSearchContext {
  channelOptions: CrudSelectOption[]
  departmentOptions: CrudSelectOption[]
  employeeOptions: CrudSelectOption[]
  isManager: boolean
  optionsLoading: boolean
}

export function createStatisticalContinueSearchItems(
  context: StatisticalContinueSearchContext
): CrudSearchItem[] {
  const controlClass = 'statistical-continue-page__search-control'

  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      controlClass,
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择直播间',
      options: context.channelOptions
    },
    {
      label: '访问时间',
      prop: 'accessTime',
      type: 'dateTimeRange',
      controlClass: 'statistical-continue-page__date-control',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      shortcuts: useSearchDateShortcut(),
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    },
    {
      label: '持续听课天数',
      prop: 'continueAttend',
      type: 'select',
      controlClass,
      clearable: true,
      placeholder: '请选择天数',
      options: [
        { label: '≥ 3天', value: '' },
        { label: '≥ 4天', value: '4' },
        { label: '≥ 5天', value: '5' },
        { label: '≥ 6天', value: '6' },
        { label: '≥ 7天', value: '7' },
        { label: '≥ 8天', value: '8' },
        { label: '≥ 9天', value: '9' },
        { label: '≥ 10天', value: '10' }
      ]
    },
    {
      label: '部门',
      prop: 'deptId',
      type: 'select',
      controlClass,
      clearable: true,
      disabled: !context.isManager,
      placeholder: '请选择部门',
      options: context.departmentOptions
    },
    {
      label: '员工',
      prop: 'empIds',
      type: 'select',
      controlClass,
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择员工',
      options: context.employeeOptions
    }
  ]
}

export const statisticalContinueTableColumns: CrudTableColumn<StatisticalContinueRecord>[] =
  [
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      slot: 'consumer',
      minWidth: 160,
      align: 'left',
      showOverflowTooltip: true
    },
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      prop: 'deptName',
      label: '所属部门',
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      prop: 'empName',
      label: '所属员工',
      minWidth: 120,
      showOverflowTooltip: true
    }
  ]
